import React from 'react'
import { formSettings, domainSettings } from '../../../../../config/generatedConfig'
import helpers from './helpers'
import RefundModalContent from './RefundModalContent'

const voucherLanguage = ['de', 'en'].indexOf(domainSettings.language.toLowerCase()) >= 0 ? domainSettings.language.toLowerCase() : 'de'
const voucherTranslations = require(`../../../../config/components/vouchers/${voucherLanguage}/`)


class RefundModal extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { handleRefundRequest, isVisible, voucher, closeModal } = this.props
    if (!voucher) return null
    const {
      bookingRef,
      id,
      refundValue,
      remainingValue,
      totalValue,
      nonFlex,
      redemptions,
      cancellationFeeRedeemable
    } = voucher

    const style = {display: (isVisible ? 'block' : 'none')}

    const getModalContent = () => {
      const refundFee = totalValue - refundValue
      const hasRedemptions = redemptions && redemptions.length

      let rule

      if (nonFlex) {
        rule = 'nonFlex'
      } else if (!refundValue && hasRedemptions) {
        rule = 'hasRedemption'
      } else if (!refundValue && !hasRedemptions) {
        rule = 'none'
      }  else if (refundValue && !refundFee) {
        rule = 'full'
      } else if (refundValue && refundFee) {
        rule = 'partial'
      }

      return <RefundModalContent
        refundRule={rule}
        refundValue={refundValue}
        refundFee={refundFee}
        cancellationFeeRedeemable={cancellationFeeRedeemable}
        handleRefundRequest={handleRefundRequest}
        closeModal={closeModal}
        id={id}
      />
    }

    return (
      <div role='dialog' className={`modal fade ${isVisible ? 'in' : ''}`} id='voucher-refund-modal' style={style}>
        <div className='modal-dialog'>
          <div className='modal-content p-0'>
            <div className='modal-header text-center'>
              <button className='close' name='close-refund-modal' type='button' aria-label='Close' onClick={this.props.closeModal}><span aria-hidden='true'>×</span></button>
              <img src='https://dmy0b9oeprz0f.cloudfront.net/holidayextras.co.uk/brand-guidelines/logo-tags/png/ticket.png' alt='holiday extras logo' />
              <h2 className='modal-title'>{voucherTranslations.refundingYourVoucher} - {bookingRef}</h2>
              <h3 className='mt-0'>{voucherTranslations.balance} - {helpers.toPrice(remainingValue.toString())}</h3>
            </div>
            <div className='modal-body py-4 px-5'>
              {getModalContent()}
            </div>
          </div>
        </div>
      </div>
    )

  }
}

export default RefundModal



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/vouchers/RefundModal.jsx